export const faq = {
  seo: {
    title: 'Veelgestelde vragen over Bistroo | Bistroo',
    description: 'Antwoorden op de meest gestelde vragen over Bistroo: prijzen, onboarding, hardware, uitbetalingen en meer.',
  },
  hero: {
    heading: {
      1: 'De',
      2: 'meest gestelde vragen',
      3: 'op een overzichtelijke pagina',
    },
    description: {
      1: 'Heb je een vraag? Grote kans dat je het antwoord hieronder al vindt. We hebben de meest gestelde vragen voor je op een rij gezet, zodat je snel en eenvoudig zelf verder kunt.',
      2: 'Kom je er toch niet uit? Dan staat onze klantenservice natuurlijk voor je klaar.',
    },
  },
  questions: {
    1: {
      question: 'Wat is Bistroo en hoe werkt het?',
      answer:
        'Bistroo is een innovatief softwarebedrijf dat zich richt op de digitalisering van de horeca. Het bedrijf biedt gebruiksvriendelijke tools aan waarmee restaurants, cafés en andere horecazaken hun online aanwezigheid kunnen verbeteren en zelfstandig kunnen beheren.',
      bullet_title: 'Bistroo levert onder andere:',
      bullets: {
        1: 'Websites en webshops voor horecazaken, volledig aanpasbaar naar jouw wensen.',
        2: 'QR-modules waarmee klanten gemakkelijk via hun mobiel op locatie kunnen bestellen en betalen.',
        3: 'Een beheersysteem waarin je alles zelf kunt instellen: menu’s, openingstijden, acties, bezorg instellingen, en meer.',
      },
      how: 'Hoe werkt het?',
      list: {
        1: 'Je maakt een account aan bij Bistroo en richt jouw digitale omgeving in. Je kunt je menukaart toevoegen, instellingen wijzigen, de betaalmethode koppelen en zelf bepalen hoe jouw online restaurant eruitziet.',
        2: 'Zodra alles klaar staat, gaat jouw website, webshop of QR-module live. Klanten kunnen je vinden, bestellingen plaatsen of ter plekke via QR bestellen.',
        3: 'Jij houdt volledige controle over je winkel. Alles is zelf instelbaar, maar als je hulp nodig hebt, staat het supportteam van Bistroo voor je klaar om je optimaal te ondersteunen.',
      },
    },
    2: {
      question: 'Is Bistroo gratis?',
      answer:
        'Ja, Bistroo biedt een gratis instappakket aan. Dit betekent dat je als horecaondernemer kosteloos gebruik kunt maken van de modules, zonder maandelijkse abonnementskosten of opstartkosten.',
      how: 'Hoe werkt het gratis pakket?',
      bullets: {
        1: 'Gratis opstarten: Je kunt meteen beginnen met het opzetten van je webshop en website, geen opstartkosten! Alleen bij de QR module rekenen wij de kostprijs van de stickers door.',
        2: 'Geen abonnementskosten: wij rekenen geen vaste abonnementskosten, wij vragen alleen een volume-fee percentage bij een geslaagde bestelling.',
        3: 'Zelf in te richten: Je hebt toegang tot alle basisfuncties om jouw digitale omgeving volledig naar wens in te richten.',
        4: 'Support beschikbaar: Ook als gratis gebruiker kun je rekenen op ondersteuning van ons supportteam.',
        5: 'Makkelijk switchen: je kan elke maand switchen naar een ander pakket.',
      },
      why: 'Waarom dit model?',
      why_answer:
        'Bistroo wil horecaondernemers de vrijheid geven om zonder financiële drempels te starten met digitaliseren. Pas als je daadwerkelijk resultaat behaalt, betaal je een volume-fee percentage. Dit maakt het een laagdrempelige en eerlijke oplossing voor zowel startende als gevestigde horecazaken.',
    },
    3: {
      question: 'Kan ik Bistroo eerst uitproberen?',
      answer:
        'Ja, zeker! Alle pakketten van Bistroo zijn 30 dagen gratis uit te proberen. Dit betekent dat je zonder verplichtingen gebruik kunt maken van alle functionaliteiten van het pakket dat bij jouw horecazaak past, of je nu kiest voor een website, webshop of QR-bestelmodule.',
      what: 'Wat houdt de proefperiode in?',
      bullets: {
        1: '30 dagen gratis toegang tot alle functies van het gekozen pakket.',
        2: 'Volledige vrijheid om jouw digitale omgeving in te richten en te testen.',
        3: 'Ondersteuning van het supportteam tijdens de volledige proefperiode.',
        4: 'Hardware in bruikleen (mits van toepassing) gedurende de proefperiode.',
      },
    },
    4: {
      question: 'Hoe gaan jullie om met extra verzoeken?',
      answer: {
        1: 'Bij Bistroo nemen we extra verzoeken serieus. Ons supportteam verwerkt dagelijks alle binnenkomende verzoeken, zodat je snel geholpen wordt en jouw online omgeving altijd up-to-date blijft.',
        2: 'Daarnaast houden we wekelijks een overleg waarin we alle binnengekomen feedback en verzoeken bespreken. Tijdens dit overleg beoordelen we welke suggesties kunnen worden meegenomen in toekomstige feature-updates.',
      },
    },
    5: {
      question: 'Hoe werken uitbetalingen bij Bistroo?',
      answer: {
        1: 'Bij Bistroo zijn uitbetalingen eenvoudig, flexibel en volledig geautomatiseerd.',
        2: 'Kortom: Jij houdt de controle over je geldstromen, en wij zorgen voor een soepel en overzichtelijk proces. Net zo makkelijk.',
      },
      bullets: {
        1: 'Koppel je betaalprovider aan ons systeem.',
        2: 'Bepaal zelf het uitbetalingsmoment: je kiest of je dagelijks, wekelijks of maandelijks uitbetaald wilt worden precies zoals het bij jouw onderneming past.',
        3: 'Automatische facturatie: Voor elke uitbetaling wordt automatisch een factuur gegenereerd, zodat je administratie altijd klopt en up-to-date is.',
      },
    },
    6: {
      question: 'Waarom zou ik voor jullie kiezen? Wat maakt jullie anders?',
      answer: {
        1: 'Met Bistroo ben jij weer volledig de ondernemer. Onze oplossing geeft jou als verkoper de regie over jouw online winkel. Je wordt écht proceseigenaar, met volledige controle over je online restaurant. Wij bieden alle tools en ondersteuning die je nodig hebt om jouw restaurant online succesvol te maken.',
        2: 'In de Manager, ons gebruiksvriendelijke backoffice dashboard beheer je eenvoudig alles in realtime: van menu’s, prijzen, kortingen en promoties tot (terug) betalingen en klantgegevens. Alles overzichtelijk en intuïtief, zodat jij je kunt focussen op wat echt telt.',
        3: 'Bistroo biedt daarnaast een unieke prijsstelling: jij kiest het kostenplaatje dat bij jouw onderneming past. Geen verrassingen, geen kleine lettertjes.',
        4: 'Bistroo geeft jou de vrijheid om online te ondernemen op jouw manier.',
      },
      bullets: {
        1: '30 dagen gratis uitproberen',
        2: 'Maandelijks opzegbaar',
        3: 'Geen stiekeme contracten, gewoon duidelijk en transparant',
      },
    },
    7: {
      question: 'Hoe werkt het administratief?',
      answer: {
        1: 'Bij Bistroo is de administratie zo eenvoudig mogelijk ingericht. Voor elke uitbetaling ontvang je automatisch een duidelijke omzet factuur met alle benodigde details. Zo kun je deze direct inboeken zonder gedoe.',
        2: 'Kortom: je administratie is altijd compleet, overzichtelijk en klaar voor je boekhouding zonder extra handmatige handelingen.',
      },
    },
    8: {
      question: 'Hoelang duurt het onboarden?',
      answer:
        'Bij Bistroo sta je snel online: binnen 48 uur is jouw online restaurant volledig ingericht en klaar voor gebruik. Zo kun je vrijwel direct starten met bestellen en verkopen!',
    },
    9: {
      question: 'Welke betaalmethoden ondersteunen jullie?',
      answer:
        'Bistroo werkt samen met toonaangevende betaalproviders Stripe en Mollie. Via deze partijen ondersteunen we vrijwel alle gangbare (en minder gangbare) betaalmethoden, zowel in Nederland als België. Denk aan, IDEAL, Bancontact, Apple Pay, Google Pay, Creditcard en nog veel meer betaalmethoden. Jij hebt zelf volledige controle over de betaalmethoden die jij wilt aanbieden, zet deze simpelweg aan of uit via het portaal van de betaalprovider.',
    },
    10: {
      question: 'Hoe krijgen wij de bestellingen binnen in het restaurant?',
      answer: {
        1: 'Bij Bistroo heb je meerdere flexibele opties om bestellingen binnen te krijgen, afgestemd op wat het beste bij jouw restaurant past. Bestellingen komen standaard direct binnen in je e-mailbox. Notificaties verschijnen ook direct in onze Manager app of in het manager portaal en je kan SMS notificaties aanzetten. ',
        2: 'Wil je het helemaal makkelijk maken? Wij leveren ook hardware zoals bonnenprinters en handhelds. Bovendien kunnen we in veel gevallen jouw bestaande printers in het restaurant koppelen, zodat je meteen aan de slag kunt zonder extra apparatuur.',
        3: 'Daarnaast bieden wij vaak ook koppelingen met kassasystemen, zodat bestellingen naadloos in jouw huidige workflow worden geïntegreerd. Zo bespaar je tijd en minimaliseer je fouten bij de verwerking.',
        4: 'Kortom: met Bistroo kies je zelf hoe je jouw bestellingen ontvangt, helemaal op maat van jouw bedrijfsvoering.',
      },
    },
    11: {
      question: 'Hoe kan ik starten? Wat is daar voor nodig?',
      answer:
        'Je kunt direct starten, daar is helemaal niks voor nodig. Wil je aan de slag? Maak gewoon gratis een account aan op onze website, dat kan meteen. Mocht je behoefte hebben aan specifieke hardware, dan kun je die eventueel bij ons kopen, maar het is absoluut geen vereiste.',
    },
    12: {
      question: 'Vragen jullie opstartkosten?',
      answer:
        'Bij ons betaal je géén opstartkosten. Uitsluitend voor de QR-module rekenen we de kostprijs van de QR-stickers door. ',
    },
    '15': {
      question: 'Wat maakt Bistroo uniek?',
      answer:
        'Met de software van Bistroo ben jij weer volledig ondernemer. De oplossing van Bistroo geeft jou als verkoper de regie over jouw online winkel. Je wordt écht proceseigenaar, met volledige controle over je online restaurant via het dashboard van Bistroo. Wij bieden alle tools en ondersteuning die je nodig hebt om jouw restaurant online succesvol te maken, verder kan je alles online regelen via de self-onboarding van Bistroo. Uiteraard komt het team van Bistroo ook op locatie langs als dit nodig is.',
    },
    '16': {
      question: 'Waarom is Bistroo een beter alternatief dan besteldiensten?',
      answer:
        'Bistroo onderscheidt zich door de focus op de winstgevendheid van de ondernemer. Waar traditionele besteldiensten volume-based fees tot 30% vragen en klantdata voor zichzelf houden, is Bistroo een softwareleverancier met een vast en transparant laag tarief. Het belangrijkste verschil is dat de ondernemer bij Bistroo eigenaar blijft van de klantgegevens, wat essentieel is voor marketing en klantenbinding.',
    },
    '17': {
      question: 'Welke producten levert Bistroo?',
      answer:
        'Bistroo levert een volledige e-commerce totaalpakket voor de horeca, allemaal te beheren vanuit de manager, met de volgende producten: BistrooWebshop: Een webshop voor horecazaken voor afhaal en bezorgbestellingen. BistrooPage: Website + webshop voor horecazaken via de software van Bistroo. BistrooQR: QR-module waarmee klanten op locatie kunnen bestellen en betalen. BistrooManager: Een beheersysteem genaamd voor menu- en instellingsbeheer. BistrooKiosk: Een bestelzuil, waarmee klanten op locatie hun keuze kunnen maken. BistrooPOS: Een kassa systeem met alle functionaliteiten voor afhaalrestaurants.',
    },
    '18': {
      question: 'Kan ik de software van Bistroo gebruiken als ik ook bij andere besteldiensten sta?',
      answer:
        'Ja, de software van Bistroo werkt uitstekend naast externe besteldiensten. Wij helpen je met Bistroo een eigen direct bestelkanaal op te bouwen via jouw eigen webshop, zodat je minder afhankelijk bent van een besteldienst.',
    },
    '19': {
      question: 'Heeft Bistroo een bezorgdienst?',
      answer:
        'Nee, Bistroo biedt zelf geen bezorgdienst aan zoals besteldiensten dat doen. Je kunt wel je eigen bezorgers inzetten en deze volledig beheren via de software van Bistroo.',
    },
    '20': {
      question: 'Kan ik meedoen zonder eigen bezorgers?',
      answer:
        'Ja, je kunt met de software van Bistroo starten met alleen afhalen of QR-bestellen op locatie.',
    },
    '21': {
      question: 'Welke resultaten boeken restaurants gemiddeld met de software van Bistroo?',
      answer:
        'Uit onze case studies van Bistroo blijkt dat restaurants die actief inzetten op hun eigen directe kanaal hun gemiddelde marge per bestelling met 15% tot 25% zien stijgen ten opzichte van besteldiensten of telefonische bestellingen. Daarnaast zien we dat de orderwaarde bij Bistroo QR-bestellingen op locatie vaak 20% hoger ligt door slimme upsell-functies.',
    },
    '22': {
      question: 'Hoe helpt Bistroo bij het opbouwen van een vaste klantenkring?',
      answer:
        'Bij Bistroo ben jij eigenaar van de data. Je kunt klanten die al een tijdje niet hebben besteld een persoonlijke actiecode sturen. Case studies tonen aan dat restaurants met de software van Bistroo hun herhaalbezoeken exponentieel verhogen.',
    },
    '23': {
      question: 'Kan de software van Bistroo hoge volumes aan tijdens piektijden?',
      answer:
        'Zeker. We hebben diverse cases van drukke afhaalrestaurants en grote terrassen die tijdens piekmomenten volledig vertrouwen op de stabiele software van Bistroo. De directe koppeling binnen het systeem van Bistroo zorgt ervoor dat de foutmarge in de keuken tot bijna nul wordt gereduceerd. De slimme tijdsloten zorgen voor een goede verdeling van bestellingen of producten binnen de spits waar dit via andere systemen of de telefoon niet te regelen is.',
    },
    '24': {
      question: 'Hoe ervaren ondernemers de overstap naar de software van Bistroo?',
      answer:
        'Ondernemers noemen vaak de "vrijheid" van Bistroo vergeleken met besteldiensten als grootste pluspunt. Daarnaast zien restaurants een enorme efficiëntieslag ten opzichte van telefonische bestellingen. De mogelijkheid om direct je menu aan te passen of een actie live te zetten via de Bistroo Manager wordt ook als zeer waardevol ervaren.',
    },
    '26': {
      question:
        'Is de software van Bistroo geschikt voor franchiseketens of bedrijven met meerdere locaties?',
      answer:
        'Ja, de Bistroo Manager is ontworpen voor schaalbaarheid. Vanuit één centraal account kunnen ondernemers meerdere vestigingen beheren met de software van Bistroo. Onze split payment constructie maakt de betalingen stroom ook heel soepel zonder extra administatie.',
    },
    '27': {
      question:
        "Biedt Bistroo ook oplossingen voor 'dark kitchens' of bezorgrestaurants zonder zitplaatsen?",
      answer:
        'Absoluut. Voor dark kitchens biedt Bistroo een gestroomlijnde workflow waarbij bestellingen direct op de handheld binnenkomen, waardoor onafhankelijkheid van externe besteldiensten wordt gewaarborgd door de software van Bistroo.',
    },
    '28': {
      question: 'Met welke kassa systemen werkt de software van Bistroo samen?',
      answer:
        'De software van Bistroo werkt samen met Lightspeed, Winston Pos, Untill en Cashdesk. Daarnaast levert Bistroo een eigen kassa systeem dat volledig gekoppeld is met onze andere producten.',
    },
    '29': {
      question: 'Kan ik mijn boekhouding koppelen aan het systeem van Bistroo?',
      answer:
        'Bistroo faciliteert een efficiënte administratie door exports aan te bieden die compatibel zijn met de meeste boekhoudpakketten. Dankzij de samenwerking met betaalprovider Stripe worden financiële stromen overzichtelijk gerapporteerd, wat de verwerking in pakketten zoals Exact Online, Twinfield of Yuki aanzienlijk versnelt.',
    },
    '30': {
      question: 'Maken jullie een website voor mij met de software van Bistroo?',
      answer:
        'Ja, met het product BistrooPage maken we een volledige website voor je die geoptimaliseerd is voor conversie.',
    },
    '31': {
      question: 'Ik heb zelf al een website, kan ik de software van Bistroo dan nog gebruiken?',
      answer:
        'Ja, via de Bistroo Button kun je eenvoudig je Bistroo webshop koppelen aan je bestaande site.',
    },
    '32': {
      question: 'Ik heb zelf al een domein, kan ik dat koppelen aan de software van Bistroo?',
      answer:
        'Ja, je kunt jouw domein koppelen aan een nieuwe BistrooWebshop of BistrooPage via een verhuiscode die het team van Bistroo voor je verwerkt.',
    },
    '33': {
      question: 'Hoe helpt de software van Bistroo bij het oplossen van personeelstekorten?',
      answer:
        'Door de inzet van de Bistroo QR-module of de BistrooKiosk kunnen gasten zelfstandig bestellen. Dit vermindert de druk op het personeel, waardoor zij met hulp van de software van Bistroo meer werk kunnen verzetten.',
    },
    '34': {
      question: 'Hoe helpt Bistroo mijn restaurant om hoger in Google te komen?',
      answer:
        'Bij het product BistrooPage optimaliseren wij de website technisch (SEO). Doordat het menu via Bistroo in HTML-tekst op de site staat, kan Google de gerechten indexeren.',
    },
    '35': {
      question: 'Kan ik de software van Bistroo gratis uitproberen?',
      answer:
        'Ja, alle pakketten van Bistroo zijn 30 dagen gratis uit te proberen zonder verplichtingen en zonder opstartkosten!',
    },
    '36': {
      question: 'Wat zijn de kosten van de software van Bistroo?',
      answer:
        'Bistroo rekent een vast maandbedrag bij de abonnementen, of een gratis module waarbij je alleen een volume-fee per bestelling betaalt. Extra kosten zoals Bistroo hardware worden apart berekend. Geen opstartkosten! Kijk even op de website voor de specifieke prijzen voor de producten.',
    },
    '37': {
      question: 'Kan ik maandelijks opzeggen bij Bistroo?',
      answer: 'Onze abonnementen zijn altijd maandelijks opzegbaar.',
    },
    '38': {
      question: 'Krijg ik korting als ik een jaar vooruit betaal bij Bistroo?',
      answer:
        'Ja, mocht je een jaar vooruit willen betalen krijg je bij Bistroo een korting op het abonnement.',
    },
    '39': {
      question: 'Wat is er nodig om te starten bij Bistroo?',
      answer:
        'Je kunt direct starten met Bistroo, daar is helemaal niks voor nodig behalve een account op de website van Bistroo.',
    },
    '40': {
      question: 'Wat heb ik nodig om te starten met de software van Bistroo?',
      answer:
        'Een mobiel apparaat, internet en je restaurantgegevens zijn voldoende om met de software van Bistroo te beginnen.',
    },
    '41': {
      question: 'Hoe moet ik me aanmelden bij Bistroo?',
      answer:
        'Je kunt je aanmelden via de website van Bistroo of via WhatsApp op 085-0250205. Zelf een account aanmaken kan op merchant.bistroo.nl/register.',
    },
    '42': {
      question: 'Krijg ik hulp bij het opzetten van mijn Bistroo account?',
      answer: 'Ja, Bistroo biedt persoonlijke onboarding, zowel op locatie als op afstand.',
    },
    '43': {
      question: 'Krijg ik hulp bij het opzetten van mijn online menu in de software van Bistroo?',
      answer:
        'Zeker! Het supportteam van Bistroo helpt bij het inrichten van je menu en geeft uitleg over wijzigingen.',
    },
    '44': {
      question:
        'Wat als ik geen verstand heb van techniek, kan ik dan de software van Bistroo gebruiken?',
      answer:
        'Zeker! De software van Bistroo is zeer gebruiksvriendelijk ingericht en we helpen je stap voor stap.',
    },
    '45': {
      question: 'Welke hardware levert Bistroo?',
      answer:
        'Bistroo levert een handheld device van Sunmi, wij kunnen laptops leveren op aanvraag, wij leveren USB/WiFi/Internet bonprinters van het merk Epson en een cloudprinter van het merk Sunmi. Wij leveren ook de hardware voor ons kassa systeem, bestaande uit: een pin terminal, een Sunmi display, een Sunmi cloud printer en een kassa lade. Andere hardware is op aanvraag mogelijk, ons software draait op alles. Voor onze bestelzuilen zijn er verschillende modellen te koop, deze verschillen van een instapmodel tot hele uitgebreide dubbelwandige zuilen.',
    },
    '46': {
      question: 'Hoe werkt de handheld van Bistroo?',
      answer:
        'De Sunmi handheld van Bistroo is eenvoudig te gebruiken voor orderbeheer en bonprinten met de software van Bistroo.',
    },
    '47': {
      question: 'Werkt de software van Bistroo op mijn bestaande hardware?',
      answer: 'Ja, de software van Bistroo draait op elk modern apparaat met een browser.',
    },
    '48': {
      question: 'Wat moet ik doen als de software van Bistroo geen internetverbinding heeft?',
      answer:
        'Gebruik een hotspot of neem contact op met de klantenservice van Bistroo om een simkaart te activeren.',
    },
    '49': {
      question: 'Hoe wissel ik van wifi op de handheld van Bistroo?',
      answer:
        'Via de instellingen van het Bistroo apparaat kun je eenvoudig van netwerk wisselen voor een stabiele verbinding.',
    },
    '50': {
      question: 'Zit er een simkaart in de apparatuur van Bistroo?',
      answer:
        'Ja, in de apparatuur van Bistroo zit een simkaart die op verzoek geactiveerd kan worden.',
    },
    '51': {
      question: 'De printer van de handheld werkt niet, wat moet ik doen?',
      answer:
        'Controleer de bonrol en de verbinding, of neem contact op met de support van Bistroo.',
    },
    '52': {
      question: 'Hoe vervang ik de bonrol in de apparatuur van Bistroo?',
      answer:
        'Plaats de rol met de papierkant naar voren in het Bistroo apparaat en test een print.',
    },
    '53': {
      question: 'Welke maat bonrol moet ik gebruiken voor de Bistroo handheld?',
      answer: 'In de Sunmi handheld van Bistroo passen 57x40x12 thermo witte bonrollen.',
    },
    '54': {
      question: 'Krijg ik bonrollen geleverd door Bistroo?',
      answer:
        'Je krijgt standaard een rolletje bij levering van Bistroo. Extra rollen kunnen bij Bistroo worden besteld via 123 inkt, voor de handheld is het deze URL: https://www.123inkt.nl/123inkt-kassarol-57x40x12-thermo-wit-5-stuks-40349EC-K-6023C-i52200-t4160297.html',
    },
    '55': {
      question: 'Vervangt Bistroo een kapotte printer?',
      answer:
        'Ja, mits er zorgvuldig met de apparatuur van Bistroo is omgegaan, vervangen wij deze onder normale omstandigheden.',
    },
    '56': {
      question: 'Kan ik de taal op de handheld aanpassen?',
      answer:
        'Ja, via instellingen op het apparaat. Echter wordt Nederlands of Engels aanbevolen voor de software van Bistroo.',
    },
    '57': {
      question: 'Waar kan ik de bonrollen voor de handheld van Bistroo kopen?',
      answer:
        'Dat kan via 123 inkt, via deze link: https://www.123inkt.nl/123inkt-kassarol-57x40x12-thermo-wit-5-stuks-40349EC-K-6023C-i52200-t4160297.html',
    },
    '58': {
      question: 'Welke bestelzuilen levert Bistroo?',
      answer:
        'Wij bieden een instapmodel van Sunmi aan, maar kunnen ook op maat gemaakte modellen aanleveren via onze partners, informeer voor de mogelijkheden.',
    },
    '59': {
      question: 'Ik heb al hardware, kan Bistroo die gebruiken?',
      answer:
        'Over het algemeen ja, echter moeten wij even een duidelijke foto of model nummer krijgen om zeker te weten dat onze software goed kan draaien op de bestaande hardware. In principe is onze regel dat wij op alles kunnen draaien.',
    },
    '60': {
      question: 'Ik wil mijn winkel op Bistroo sluiten, hoe doe ik dat?',
      answer:
        'Zet de online winkel op gesloten in De Bistroo Manager of op de handheld via de schuifknop. Om op afstand te sluiten ga naar merchant.bistroo.nl.',
    },
    '61': {
      question: 'Hoe open ik mijn winkel op Bistroo op een extra dag?',
      answer:
        'Open je winkel via de schuif in de Bistroo Manager of stel afwijkende openingstijden in onder ‘openingstijden & bediening’ als u afwijkt van uw standaard openingstijden.',
    },
    '62': {
      question: 'Moet ik mijn winkel op Bistroo handmatig weer openen na sluiting?',
      answer:
        'Nee. Zodra de ingestelde datum is verstreken, schakelt de Bistroo Manager automatisch weer over naar je reguliere weekplanning.',
    },
    '63': {
      question: 'Kan ik een volledige vakantieperiode inplannen in de software van Bistroo?',
      answer:
        'Ja. Je kunt meerdere regels toevoegen bij de afwijkende openingstijden. Voor elke vakantiedag voeg je eenvoudig een nieuwe regel toe in de Bistroo Manager.',
    },
    '64': {
      question: 'Hoe pas ik levertijden aan in de software van Bistroo?',
      answer:
        'Via De Bistroo Manager > Vestigingsinstellingen > ‘openingstijden & bediening’ > openingstijden of afwijkende tijden per distributiekanaal (afhalen, bezorgen, op locatie).',
    },
    '65': {
      question: 'Hoe pas ik mijn prijzen aan bij Bistroo?',
      answer:
        'Ga naar Producten Voorraad in De Bistroo Manager en klik op het product om de prijs aan te passen. U kan naar een product zoeken door in het zoekveld te typen.',
    },
    '66': {
      question: 'Hoe update ik mijn menu in de software van Bistroo?',
      answer:
        'Pas producten of categorieën aan in De Bistroo Manager. Je kunt ook een nieuw menu aanmaken en koppelen aan de software van Bistroo.',
    },
    '67': {
      question: 'Hoe verberg ik tijdelijk producten in de software van Bistroo?',
      answer:
        'Zet het product tijdelijk uit in De Bistroo Manager via het schuifje bij het product. Of klik op menu in de handheld van Bistroo en gebruik daar de schuifjes per product.',
    },
    '68': {
      question: 'Hoe stel ik bezorggebieden in binnen de software van Bistroo?',
      answer:
        'Ga naar ‘openingstijden & bediening’ > Bezorgen in de Bistroo Manager en voeg daar gebieden toe of pas deze aan.',
    },
    '69': {
      question: 'Hoe verander ik bezorgkosten in de software van Bistroo?',
      answer:
        'Via ‘openingstijden & bediening’ > Bezorgen in De Bistroo Manager pas je de bezorgkosten per gebied aan.',
    },
    '70': {
      question: 'Ik wil gratis bezorgen via de software van Bistroo, hoe stel ik dat in?',
      answer:
        'Zet de bezorgkosten op 0 voor het gewenste postcodegebied in de instellingen van de Bistroo Manager.',
    },
    '71': {
      question: 'Kan ik een lunch- en dinerkaart tegelijk aanbieden via de software van Bistroo?',
      answer:
        'Ja, je kunt meerdere menu’s aanmaken en tijdgebonden activeren via de software van Bistroo.',
    },
    '72': {
      question: 'Kan ik een menu alleen tijdens een bepaalde tijd aanbieden?',
      answer:
        'Ja, stel via de Bistroo Manager in wanneer het menu beschikbaar is (bijvoorbeeld alleen lunch of diner).',
    },
    '73': {
      question: 'Kan ik producten tijdens een bepaalde tijd aanbieden?',
      answer: 'Ja, via de Bistroo Manager kun je tijdsloten instellen per categorie.',
    },
    '74': {
      question: 'Waarom verschijnt ‘geen drankje’ op de bon van Bistroo?',
      answer:
        'Dit gebeurt wanneer een product een keuzemenu (dropdown) heeft waarin ‘geen drankje’ als standaardwaarde staat ingesteld in de Bistroo Manager.',
    },
    '75': {
      question: 'Is het nodig dat bijvoorbeeld ‘geen drankje’ op de bon van Bistroo staat?',
      answer:
        'Nee. In de meeste gevallen is dit overbodig. Je kunt in de Bistroo Manager instellen dat de eerste waarde optioneel is, waardoor deze niet wordt afgedrukt.',
    },
    '76': {
      question: 'Wanneer krijg ik mijn uitbetaling van Bistroo?',
      answer:
        'Uitbetalingen van Bistroo zijn gekoppeld aan het schema van de betaalprovider Stripe. De omzet voor online bestellingen wordt standaard berekend van donderdag t/m woensdag, en op maandag uitbetaald. Voor pinbetalingen is deze cyclus anders.',
    },
    '77': {
      question: 'De uitbetaling van Bistroo klopt niet, hoe kan dat?',
      answer:
        'Controleer de omzetfacturen in de Bistroo Manager. Hier staat de inhouding van Bistroo duidelijk vermeld.',
    },
    '78': {
      question: 'Hoe controleer ik mijn uitbetalingen in de software van Bistroo?',
      answer:
        'Log in op De Bistroo Manager via merchant.bistroo.nl > Facturen. Hier zie je per transactie precies what er door Bistroo is uitbetaald.',
    },
    '79': {
      question: 'Ik heb te weinig geld uitbetaald gekregen van Bistroo, hoe kan dit?',
      answer:
        'Log in via de Bistroo manager via merchant.bistroo.nl en kijk onder het kopje facturen en open de meest recente factuur. Je ziet hier welke transacties mee zijn gegaan in de uitbetaling. Onthoud dat de standaard wekelijkse cyclus van Stripe voor online betalingen van donderdag t/m woensdag loopt, dit wordt vervolgens uitbetaald op maandag. Kijk ook even of je geen terugbetalingen hebt gedaan in de periode, dit staat ook duidelijk op de omzet factuur vermeld.',
    },
    '80': {
      question: 'Welke andere kosten worden ingehouden door Bistroo?',
      answer:
        'Transactiekosten van Stripe, mogelijk pin kosten van de bank en mits van toepassing hardware-afbetalingen of correcties worden op de uitbetaling van Bistroo ingehouden.',
    },
    '81': {
      question: 'Hoe ontvang ik mijn facturen van Bistroo?',
      answer:
        'Facturen vind je in De Bistroo Manager onder het kopje Facturatie. Je krijgt deze ook wekelijks van Bistroo naar je mailadres toegestuurd.',
    },
    '82': {
      question: 'Hoe download ik mijn facturen van Bistroo?',
      answer:
        'Ga naar Facturen in De Bistroo Manager, kies de periode en download als PDF- en excelbestand.',
    },
    '83': {
      question: 'Hoe weet ik mijn dagomzet bij Bistroo?',
      answer:
        'Je vindt je dagomzet in De Bistroo Manager op het dashboard of via rapportages uitdraaien op de handheld van Bistroo.',
    },
    '84': {
      question: 'Hoe print ik mijn dagomzet via Bistroo?',
      answer:
        'Via de rapportage-sectie in De Bistroo Manager kun je dagrapporten exporteren en printen. Klik hiervoor in de handheld van Bistroo op het icoon linksboven in het scherm.',
    },
    '85': {
      question: 'Wat moet ik doen als ik een fout heb gemaakt in een bestelling van de klant?',
      answer:
        'Je kunt als restauranthouder de bestelling openen en een (gedeeltelijke) terugbetaling uitvoeren via de handheld van Bistroo of De Bistroo Manager.',
    },
    '86': {
      question: 'Hoe annuleer ik een bestelling in de software van Bistroo?',
      answer:
        'Open de bestelling in de manager van Bistroo en kies voor terugbetalen. Daarmee is de order geannuleerd.',
    },
    '87': {
      question: 'Hoe los ik een klacht op met de software van Bistroo?',
      answer:
        'Los een klacht direct op met de consument en geef eventueel korting of een terugbetaling via de software van Bistroo.',
    },
    '88': {
      question: 'Lossen jullie klachten op bij Bistroo?',
      answer:
        'Bistroo begeleidt bij klachten, maar de restauranthouder blijft verantwoordelijk voor de service, de kwaliteit van het eten en de levering van het eten.',
    },
    '90': {
      question: 'Wat als een klant niet open doet bij een Bistroo bestelling?',
      answer:
        'Probeer eerst telefonisch contact op te nemen. De bestelling via Bistroo is altijd vooraf betaald, dus u loopt geen direct financieel risico.',
    },
    '91': {
      question: 'Ik wil een actiedag instellen, biedt de software van Bistroo die mogelijkheid?',
      answer:
        'Gebruik de kortingsmodule in de Bistroo Manager om een kortingsactie in te plannen op specifieke dagen of voor een bepaalde periode.',
    },
    '92': {
      question: 'Helpt Bistroo mij met reclame maken?',
      answer:
        'Ja, Bistroo biedt 1.000 gratis flyers aan bij een eerste actie. Daarnaast kun je whitelabel flyers laten drukken via Bistroo.',
    },
    '94': {
      question: 'Hoe snel passen jullie mijn menu aan als ik een wijziging doorgeef aan Bistroo?',
      answer:
        'Bistroo streeft ernaar wijzigingen binnen 24-48 uur door te voeren. Bij spoed helpt Bistroo sneller.',
    },
    '95': {
      question: 'Hoe bereik ik de klantenservice van Bistroo?',
      answer:
        "Het team van Bistroo is telefonisch of via WhatsApp bereikbaar op 085-0250205. Ons mailadres is klantenservice{'@'}bistroo.nl.",
    },
    '96': {
      question:
        'Hoe kan ik testen of mijn wijzigingen in de software van Bistroo goed zijn gelukt?',
      answer:
        'Neem contact op met de klantenservice van Bistroo om de online omgeving tijdelijk in test-modus te laten zetten.',
    },
  },
}
